import { FC } from 'react';
import {
  Avatar,
  Flex,
  Text,
  Heading,
  SimpleGrid,
  Skeleton,
  VStack,
  LinkBox,
  LinkOverlay
} from '@chakra-ui/react';
import { useQuery } from 'react-query';
import { getSpaces } from 'api/snapshot';
import { Queries } from 'types/enum';
import { Link } from 'react-router-dom';
import { useConfig } from 'store/config';

const skeletonProps = {
  height: '283px',
  maxHeight: '283px',
  startColor: 'gray.700',
  endColor: 'gray.600',
  borderRadius: 'xl'
};

const Governance: FC = () => {
  const { governanceList } = useConfig(1).commonConfig;
  const { data, error } = useQuery([Queries.SPACES], () =>
    getSpaces({ space_in: governanceList }),
  );

  if (!data) {
    // TODO: Make this logic reusable
    return (
      <SimpleGrid columns={[1, null, 2, null, 3]} spacing={[5, null, null, 10]}>
        <Skeleton {...skeletonProps} />
        <Skeleton {...skeletonProps} />
        <Skeleton {...skeletonProps} />
      </SimpleGrid>
    );
  }

  if (error) {
    return <Text>Something went wrong</Text>;
  }

  return (
    <SimpleGrid columns={[1, null, 2, null, 3]} spacing={[5, null, null, 10]}>
      {data.spaces.map((space) => (
        <LinkBox
          as={Flex}
          height='283px'
          maxHeight='283px'
          borderRadius='xl'
          justifyContent='center'
          alignItems='center'
          bg='gray.800'
        >
          <LinkOverlay as={Link} to={`/governance/${space.id}`}>
            <VStack spacing={4}>
              <Avatar
                size='xl'
                ignoreFallback
                bg='transparent'
                name={space.name}
                src={`https://ipfs.io/ipfs/${space.avatar.replace(
                  'ipfs://',
                  ''
                )}`}
              />
              <Heading size='lg'>{space.name}</Heading>
              <Text>
                {
                  data.proposals.filter(
                    (proposal) => proposal.space.id === space.id
                  ).length
                }{' '}
                active proposals
              </Text>
            </VStack>
          </LinkOverlay>
        </LinkBox>
      ))}
    </SimpleGrid>
  );
};

export default Governance;
